import React from 'react';
import FormButton from "../Components/Buttons/FormButton";


type RecountedProps = {
    handleClose: () => void;
};

const RecountedLayout: React.FC<RecountedProps> = ({ handleClose }) => {
    const handleSubmit = (event: React.FormEvent) => {
        event.preventDefault();
        handleClose();
    };

    return (
        <>
            <div className="d-flex justify-content-center">
                <div className="px-2">
                    <label className="w-100 text-center fs-16 mb-2">This line item has been recounted.</label>
                </div>
            </div>

            <div className="d-flex justify-content-end mt-4 gap-2">
                <FormButton
                    tabIndex={25}
                    className="sph-btn me-4"
                    handleClick={() => handleClose()}>
                    Close
                </FormButton>
            </div>
        </>
    );
};

export default RecountedLayout;
